import React, { Suspense } from "react";
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux'; // Creates the Central Redux Store
import { Provider } from 'react-redux'; // Makes sure the Store is connected to React
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistStore, persistReducer, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import App from './App.js';
import reducer from './Reducers'; // Gets the root reducer to be used by the store
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

const Loader = () => <div>loading...</div>;

const persistConfig = {
  key: 'root',
  whitelist: ['authReducer'],
  storage: storage,
};

const pReducer = persistReducer(persistConfig, reducer);

//hook up the redux devtools browser extension
const store = createStore(pReducer,
  composeWithDevTools (
    applyMiddleware(thunk)
  )
);

const persistor = persistStore(store);

render(
  <Provider store={store}>
  <PersistGate loading={<Loader />} persistor={persistor}>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);